import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { GET_STARTED_URL, BOOK_DEMO_URL } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { Reveal } from '../ui/Reveal';
type ProcessCtaProps = {
  placement: string;
  title?: string;
  body?: string;
  primaryLabel?: string;
};

/** Closing call to action shared by the homepage and platform pages. */
export function ProcessCta({
  placement,
  title = 'What Process Does Your Team Run?',
  body = 'Turn your current diligence workflow into an agentic process.',
  primaryLabel = 'Build Your First Process'
}: ProcessCtaProps) {
  return <section aria-labelledby={`${placement}-cta-heading`} className="dgpt-dark relative overflow-hidden bg-night-2" data-id="element-1221" data-mp="1vz0u7xh2p954">
      <div className="dgpt-night-grid sf-fade-mask pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-1222" data-mp="20wk7ov5y5hw0" />
      <Reveal className="relative mx-auto flex w-full max-w-[900px] flex-col items-center px-4 py-24 text-center sm:px-6 lg:py-32" data-id="element-1223" data-mp="1lsw9wxswhf9">
        <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-night-muted" data-id="element-1224" data-mp="20me9qg93o59b">DiligenceGPT™</p>
        <h2 id={`${placement}-cta-heading`} className="sf-display on-dark mt-5 text-balance text-[34px] leading-[1.02] text-night-text sm:text-[52px] lg:text-[64px]" data-id="element-1225" data-mp="1vvxssm62m1i7">
          {title}
        </h2>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-night-muted sm:text-lg" data-id="element-1226" data-mp="1lyjeot7mdot2">{body}</p>
        <div className="mt-10 flex w-full flex-col gap-3 sm:w-auto sm:flex-row" data-id="element-1227" data-mp="2jk79j9offz2h">
          <CtaButton href={GET_STARTED_URL} variant="violet" size="xl" event="primary_cta_click" eventParams={{
          placement: `${placement}_final`,
          cta: 'build_first_process'
        }} className="w-full sm:w-auto" data-id="element-1228" data-mp="2elw2f6pio2ny">
            {primaryLabel}
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1229" data-mp="y8yygi2up5nh" />
          </CtaButton>
          <CtaButton href={BOOK_DEMO_URL} variant="outlineDark" size="xl" event="enterprise_demo_click" eventParams={{
          placement: `${placement}_final`
        }} className="w-full sm:w-auto" data-id="element-1230" data-mp="u62g8sh83bk2">
            Book a Demo
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1231" data-mp="lq3947n4tclx" />
          </CtaButton>
        </div>
      </Reveal>
    </section>;
}